import {
  Component,
  Input,
  EventEmitter,
} from '@angular/core';
import { BaseDropdownComponent } from '../_base-dropdown.component';


@Component({
  moduleId: module.id,
  selector: 'actions-dropdown',
  templateUrl: 'actions-dropdown.component.html',
  styleUrls: ['actions-dropdown.component.scss'],
})
export class ActionsDropdownComponent extends BaseDropdownComponent {
  @Input() alignmentRight: boolean = false;
  @Input() isVersion2: boolean = false;
  @Input() activeColor: string;

  isDropdownMenuShown: boolean = false;

  /*******************************************
   * COMPONENT HANDLERS
   *******************************************/

  onDropdownShow(show: boolean) {
    this.isDropdownMenuShown = show;
  }
}
